import log from './utility/debug.js';
import getVerticalSpacing from './getVerticalSpacing.js';
import { DEFAULT_INTER_ITEM_VERTICAL_SPACING } from './Layout.defaults.js';
export default function createVerticalSpacingHelpers(_ref) {
  var _this = this;

  var getEstimatedInterItemVerticalSpacing = _ref.getEstimatedInterItemVerticalSpacing;

  // Bind to `this` in order to prevent bugs when this function is passed by reference
  // and then called with its `this` being unintentionally `window` resulting in
  // the `if` condition being "falsy".
  this.getVerticalSpacing = function () {
    var verticalSpacing = _this.verticalSpacing;

    if (typeof verticalSpacing === 'number') {
      return verticalSpacing;
    }

    return _this.getEstimatedInterItemVerticalSpacing();
  };

  this.getVerticalSpacingBeforeResize = function () {
    var _this$getState = _this.getState(),
        beforeResize = _this$getState.beforeResize;

    if (beforeResize) {
      var verticalSpacing = beforeResize.verticalSpacing; // `beforeResize.verticalSpacing` can be `undefined`.
      // For example, if `this.updateState({ verticalSpacing })` call hasn't been applied
      // before the resize happened (in case of an "asynchronous" state update).

      if (typeof verticalSpacing === 'number') {
        return verticalSpacing;
      }

      return _this.getEstimatedInterItemVerticalSpacing();
    }
  };

  this.getEstimatedInterItemVerticalSpacing = function () {
    if (getEstimatedInterItemVerticalSpacing) {
      var estimatedVerticalSpacing = getEstimatedInterItemVerticalSpacing();

      if (typeof estimatedVerticalSpacing === 'number') {
        return estimatedVerticalSpacing;
      }

      throw new Error('[virtual-scroller] `getEstimatedInterItemVerticalSpacing()` must return a number');
    } // `DEFAULT_INTER_ITEM_VERTICAL_SPACING` will be used in server-side render
    // unless `getEstimatedInterItemVerticalSpacing()` parameter is specified.


    return DEFAULT_INTER_ITEM_VERTICAL_SPACING;
  };
  /**
   * Measures item vertical spacing, if not measured.
   * @return {object} [stateUpdate]
   */


  this.measureVerticalSpacingIfNotMeasured = function () {
    if (_this.verticalSpacing === undefined) {
      _this.verticalSpacing = measureVerticalSpacing.call(_this);
      return _this.verticalSpacing;
    }
  };

  function measureVerticalSpacing() {
    var _this$getState2 = this.getState(),
        firstShownItemIndex = _this$getState2.firstShownItemIndex,
        lastShownItemIndex = _this$getState2.lastShownItemIndex;

    log('~ Measure item vertical spacing ~');
    var verticalSpacing = getVerticalSpacing({
      itemsContainer: this.itemsContainer,
      renderedItemsCount: lastShownItemIndex - firstShownItemIndex + 1
    });

    if (verticalSpacing === undefined) {
      log('Not enough items rendered to measure vertical spacing');
    } else {
      log('Item vertical spacing', verticalSpacing);
      return verticalSpacing;
    }
  }
}
//# sourceMappingURL=VirtualScroller.verticalSpacing.js.map